import React from 'react';
import LoadingTie from './LoadingTie';

const DeviationLowSignalTie = props => {
    return (
        <div className="card card-default" style={{height: '100%'}} id="deviationLowSignal">
            <div className="card-body text-center">
                {props.lowest_rssi_value.lowestValue ? (
                    <>
                        <h4>RSSI Value</h4>
                        <br />
                        <h3>{props.lowest_rssi_value.lowestValue}</h3>
                        <br />
                    </>
                ) : (
                    <LoadingTie />
                )}
            </div>
        </div>
    );
};

export default DeviationLowSignalTie;
